module.exports = __webpack_public_path__ + "img/injection.76107367.svg";